
import { IEmployeeViewState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { EmployeeModel } from 'src/app/model/employee.model';



export const loginState: IEmployeeViewState = {
  model: new EmployeeModel()
};

const reducer = createReducer(loginState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      model: payload
    };
  })
);

export function employeeViewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
